import React from 'react';
import form from '../assets/form.pdf';

export default function Registration() {
  return (
    <div className="section-container">
    <section id="registration">
      <h2>Registration</h2>
      <p><strong>Fee:</strong> ₹20,000 | ₹15,000 for Women/SC/ST</p>
      <p><strong>Installment Option:</strong> Fee can be paid in two installments.</p>
      <p><strong>Mode:</strong> Hybrid (Online + Campus Labs)</p>
      <p><strong>Contact:</strong> skill.develop@jntugv.edu.in</p>
      <a href="https://forms.gle/8B8hWybHvdhUNmtt9" target="_blank" rel="noreferrer">
        <button>Register Now</button>
        <br></br>
              <a href={form} download className="download-btn">Download Application</a>
      </a>
    </section>
    </div>
  );
}
